import { render } from "./RoomCard.vue?vue&type=template&id=47cf944e&scoped=true"
import script from "./RoomCard.vue?vue&type=script&lang=ts"
export * from "./RoomCard.vue?vue&type=script&lang=ts"

import "./RoomCard.vue?vue&type=style&index=0&id=47cf944e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47cf944e"

export default script